/* eslint-disable @typescript-eslint/no-explicit-any,no-param-reassign */
// eslint-disable-next-line import/no-cycle
import { ControlType, type ControlProps } from '../index';

export const camelToTitle = ({ str, name }: { str?: string; name: string }): string =>
  str === null || str === undefined
    ? name
        .replace(/([a-z\d])([A-Z])/g, '$1 $2')
        .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1 $2')
        .replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
    : str;

// eslint-disable-next-line no-bitwise
export const isInt = (value: any) => !Number.isNaN(value) && ((x) => (x | 0) === x)(parseFloat(value));

export const notEmpty = (val: any) => val !== null && val !== undefined && val !== '';

const getValue = ({ value, valueAsObject }: { value: any; valueAsObject?: boolean }) => {
  if (typeof value === 'object' && valueAsObject) {
    const valueObject: any = {};
    value.map((subItemx: any) => {
      valueObject[subItemx.name] = subItemx.value;
      return null;
    });
    value = valueObject;
  }
  value =
    value === undefined || value === null
      ? null
      : value.toString() === 'true'
        ? true
        : value.toString() === 'false'
          ? false
          : value;
  return value;
};

export const output = (controls: Array<ControlProps>) => {
  const formObject: any = {};
  controls
    .filter((o) => o.control !== ControlType.LABEL && o.exclude !== true)
    // eslint-disable-next-line array-callback-return,consistent-return
    .map((item) => {
      const { valueAsObject, name } = item;

      if (name) {
        if (item.control === ControlType.CONTAINER && item.controls) {
          const formSubObject: any = {};
          item.controls
            .filter((f: ControlProps) => f.control !== ControlType.LABEL && f.exclude !== true)
            .map((subItem: any) => {
              formSubObject[subItem.name] = getValue({ value: subItem.value, valueAsObject: subItem.valueAsObject });
              return null;
            });
          formObject[name] = formSubObject;
        } else {
          formObject[name] = getValue({ value: item.value, valueAsObject });
          return null;
        }
      }
    });
  return formObject;
};

export const onUpdateControls = (e: any, item: ControlProps) => {
  if (e.target.name === item.name) {
    if (item.control === ControlType.CONTAINER && e.target.clear) {
      if (item.controls) {
        const itemControls = item.controls.map((x) => {
          x.value = x.default;
          return x;
        });
        item.controls = itemControls;
      }
    }
    item.value = e.target.value;
  }
  return item;
};

export const resetControls = (item: ControlProps) => {
  item.value = item.default;
  return item;
};
